<template>
  <v-expansion-panel 
    @click="handleExpand"
  >
    <v-expansion-panel-header>{{ $t('dtouch.workspace.iberostar.title', locale) }}</v-expansion-panel-header>
    <v-expansion-panel-content style="padding-top:16px;">
      <v-row>
        <v-col
          cols="12"
          sm="12"
          v-if="iberostarHotels"
        >
          <v-autocomplete
            v-model="iberostarHotelID"
            :items="iberostarHotels"
            :loading="loading"
            outlined
            dense
            item-text="Name"
            item-value="ID"
            :label="$t('dtouch.workspace.iberostar.hotel', locale)"
            hide-details
            @change="handleChange"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import axios from 'axios'
import api from '@/services/api'
export default {
  name: 'IberostarForm',
  props: {
    workspaceID: {
      type: String,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    onChangeData: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    loading: true,
    iberostarHotels: null,
    iberostarHotelID: null
  }),
  methods: {
    getIberostarHotels() {
      this.loading = true
      axios.get(`https://iberostar.dviewcontent.com/public/enterprises/hotels`)
      .then(response => {         
        this.iberostarHotels = response.data
        this.loading = false
      })
    },
    getData () {
      api.getItem('dtouch', `v1/system/workspaces/`, `${this.workspaceID}/iberostar`)
        .then(response => {
          this.iberostarHotelID = response ? response.IberostarHotelID : null
        })
    },
    handleExpand () {
      this.getIberostarHotels()
      if(!this.iberostarHotelID && this.workspaceID) this.getData()
    },
    handleChange () {
      this.onChangeData({
        IberostarHotelID: this.iberostarHotelID
      })
    }
  },
}
</script>

